var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'luckyBoxContainer',
    _vm.lotterySetting.boxCount === 1 ? 'center' : 'aside'
  ]},_vm._l((_vm.lotterySetting.boxCount),function(item,index){return _c('div',{key:index,class:[
      'boxItem',
      _vm.lotterySetting.boxCount === 1 ? 'bigBox' : 'smallBox'
    ],style:(_vm.openBoxId === index ? _vm.openBoxStyle : _vm.initialBoxStyle),on:{"click":function($event){return _vm.handleDraw(index)}}},[_c('div',{class:[
        _vm.lotterySetting.boxCount === 1
          ? 'largeShiningItem'
          : 'smallShiningItem',
        { showShine: _vm.openBoxId === index && _vm.showShine }
      ]})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }